<template>
  <div>
    <v-card style="padding: 10px">
      <v-card-title>اعدادات عامة</v-card-title>
      <v-container>
        <v-row>
            <v-col cols="12" lg="3" md="4" sm="6" xs="12">
              <v-switch
                :true-value="1"
                :false-value="0"
                inset
                flat
                label="الزامية الحاسبة "
                v-model="calculator_rules_active"
              />
            </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-darken-1" variant="text" @click="updateSetting">
          حفظ
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<style lang="scss">
.loadingMore {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}
.text__success {
  color: green;
}

.text__faild {
  color: red;
}
th.text-start.sortable {
  text-align: center !important;
}
i.v-icon.notranslate.mdi.mdi-dots-vertical.theme--dark {
  background: rgb(63, 14, 64);
  border-radius: 4px;
}
 .v-text-field {
   padding-top: 12px !important;
   margin-top: 4px;
 }
label.v-label.v-label--active.theme--light.primary--text {
  left: auto;
  position: absolute;
  top: 0;
  right: -11px;
}
</style>
<script>
import Axios from "axios";
import {axiosInstance} from "@/axios/config";
export default {
  name: "alertsIndex",
  components: {

  },
  data() {
    return {
      calculator_rules_active: 0,
      page: 1,
      loading: false,
    };
  },

  watch: {

  },

  methods: {
    getSettingData() {
      Axios.get(`${this.$store.state.url}/employee/admin/general-settings`, {
        headers: this.request_headers(),
      }).then((res) => {
        // console.log("res", res.data.payload.calculator_rules_active)
        this.calculator_rules_active = parseInt( res.data.payload.calculator_rules_active);
        this.loading = false;
      });
    },
    updateSetting() {
      const body = new FormData();
      body.append("calculator_rules_active", this.calculator_rules_active);

      axiosInstance
          .post(`/employee/admin/general-settings/update`, body)
          .then((res) => {
            this.showPopup("success", res.data.message);
          })
          .catch((err) => {
            this.showPopup("error", err.response.data.message);
          });
    },
  },

  created() {
    this.getSettingData();
  },
};
</script>
